import { Record } from "immutable";
import SolutionSection from "models/interfaces/situational-navigation/solutions/solution-section";
import { RecordUtils } from "@rsm-hcd/javascript-core";

const defaultValues: SolutionSection =
    RecordUtils.auditableDefaultValuesFactory<SolutionSection>({
        deletedDraftById: undefined,
        deletedDraftOn: undefined,
        publishedById: undefined,
        publishedOn: undefined,
        sectionId: 0,
        solutionId: 0,
    });

export default class SolutionSectionRecord
    extends Record(defaultValues)
    implements SolutionSection
{
    // -----------------------------------------------------------------------------------------
    // #region Properties
    // -----------------------------------------------------------------------------------------

    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // #endregion Properties

    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: SolutionSection) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<SolutionSection>} values
     */
    public with(values: Partial<SolutionSection>): SolutionSectionRecord {
        return new SolutionSectionRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
